"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _material.createSvgIcon)(/*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M15.5 10a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M15 8.5a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M13.328 5a2.5 2.5 0 0 0-1.767.732l-6.5 6.5a2.5 2.5 0 0 0 0 3.536l3.171 3.171a2.5 2.5 0 0 0 3.536 0l6.5-6.5A2.5 2.5 0 0 0 19 10.672V6.5A1.5 1.5 0 0 0 17.5 5zm-1.06 1.44a1.5 1.5 0 0 1 1.06-.44H17.5a.5.5 0 0 1 .5.5v4.172a1.5 1.5 0 0 1-.44 1.06l-6.5 6.5a1.5 1.5 0 0 1-2.12 0l-3.172-3.171a1.5 1.5 0 0 1 0-2.122z"
  })]
}), 'DiscountTag');
//# sourceMappingURL=index.js.map